var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agencies-table',{attrs:{"headers":_vm.headers,"agencies":_vm.agencies},on:{"getid":function($event){return _vm.delete_Agency($event)},"triggerPageChange":function($event){return _vm.readPaginatedAgencies($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }